/* unplugin-vue-components disabled */import { render } from "./ProHeader.vue?vue&type=template&id=2c960f6a&scoped=true"
import script from "./ProHeader.vue?vue&type=script&lang=js"
export * from "./ProHeader.vue?vue&type=script&lang=js"

import "./ProHeader.vue?vue&type=style&index=0&id=2c960f6a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\shujukeshihuaqianduan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c960f6a"]])

export default __exports__